import "@jobber/design/foundation.css";

import React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import "@jobber/design/foundation.css";

ReactDOM.render(<App />, document.getElementById("root"));
